/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetDownloadUrlQueryResponse, ArtifactsControllerGetDownloadUrlPathParams, ArtifactsControllerGetDownloadUrlQueryParams, ArtifactsControllerGetDownloadUrl404 } from "../../models/documentArtifactsController/ArtifactsControllerGetDownloadUrl";

function getArtifactsControllerGetDownloadUrlUrl(documentId: ArtifactsControllerGetDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetDownloadUrlPathParams["artifactId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/artifacts/${artifactId}/download-url` as const }  
  return res
}

/**
 * @description Generates a presigned URL for downloading the artifact file
 * @summary Get presigned download URL
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/download-url}
 */
export async function artifactsControllerGetDownloadUrl(documentId: ArtifactsControllerGetDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetDownloadUrlPathParams["artifactId"], params?: ArtifactsControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArtifactsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<ArtifactsControllerGetDownloadUrl404>, unknown>({ method : "GET", url : getArtifactsControllerGetDownloadUrlUrl(documentId, renditionId, artifactId).url.toString(), params, ... requestConfig })  
  return res.data
}